export default __webpack_public_path__ + "static/media/crypto-logo.47086df4.png";